export default {
  'brand.name': 'USFans Spreadsheet',
  'nav.home': 'Strona główna',
  'nav.guides': 'Poradniki',
  'nav.buyingGuide': 'Poradnik zakupowy',
  'nav.review': 'Recenzja',
  'nav.shipping': 'Wysyłka',
  'nav.safety': 'Bezpieczeństwo',
  'nav.faq': 'FAQ',
  'nav.buyNow': 'Kup teraz',
  'lang.label': 'Język',
  'lang.en': 'English',
  'lang.pl': 'Polski',
  'lang.es': 'Español',
  'lang.fr': 'Français',

  'footer.tagline': 'Niezależne źródło informacji o USFans Spreadsheet.',
  'footer.disclaimer': 'Ta strona jest niezależnym źródłem informacji. Nie jest oficjalnie powiązana z USFans ani przez niego wspierana, chyba że zostało to wyraźnie zaznaczone.',
  'footer.col.explore': 'Przeglądaj',
  'footer.col.guides': 'Poradniki',
  'footer.col.legal': 'Informacje prawne',
  'footer.about': 'O nas',
  'footer.contact': 'Kontakt',
  'footer.privacy': 'Prywatność',
  'footer.terms': 'Regulamin',
  'footer.disclaimerLink': 'Zastrzeżenia',
  'footer.copyright': '© 2026 USFans Spreadsheet. Wszelkie prawa zastrzeżone.',

  'common.readMore': 'Czytaj więcej',
  'common.backHome': 'Wróć na stronę główną',
  'common.explore': 'Przeglądaj USFans Spreadsheet',
};